import axios from "axios";
import contextHeader from "../auth/context.header";

// withCredentials: true — o navegador já manda o cookie HttpOnly do token automaticamente;
// não precisa mais montar o header Authorization manualmente (ver setupInterceptors.ts, que
// só monta o header pra o caso do token legado recebido via URL pela Proxy.vue).
const instance = axios.create({
  baseURL: process.env.VUE_APP_ACADEMICO_API,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    ...contextHeader()
  },
});
export default instance;

export const reportsApi = axios.create({
  baseURL: process.env.VUE_APP_REPORTS_API,
  headers: {
    "Content-Type": "application/json",
  }
});
